import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './actionLinks.module.scss';

export const SubmitAnyway = ({ onClick }) => (
    <span className={styles['container']} onClick={onClick}>
        <FormattedMessage id="validations.error.field.url.fetch.invalid.submit.anyway" defaultMessage="Submit anyway" />
    </span>
);

export const ContinueAnyway = ({ onClick }) => (
    <span className={styles['container']} onClick={onClick}>
        <FormattedMessage id="tracking.codeless.continue.anyway" defaultMessage="Continue anyway" />
    </span>
);
